// extracted by mini-css-extract-plugin
export default {"eye_chart_font":"visualAcuity_eye_chart_font__CDCL6","snellen_chart_font":"visualAcuity_snellen_chart_font__i9PFu","sloan_chart_font":"visualAcuity_sloan_chart_font__80T-R"};